/* @flow weak */
import CircleSpinner from 'components/CircleSpinner.jsx';
import Coin from 'components/Coin.jsx';
import Glyph from 'components/Glyph.jsx';
import React from 'react';
import { DeliveryStatus } from 'chat/constants/DeliveryConstants';

import cx from 'classnames';
import { values } from 'lodash';

import './styles/ReadReceipt.scss';

class ReadReceipt extends React.Component {
  static propTypes = {
    labelDisplay: React.PropTypes.bool,
    glyphDisplay: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    iconSize: React.PropTypes.oneOf(['xxxsmall', 'xxsmall', 'xsmall', 'small']),
    status: React.PropTypes.oneOf(values(DeliveryStatus)),
    errorCount: React.PropTypes.number,
  };

  static defaultProps = {
    iconSize: 'xxxsmall',
    onClick: () => {},
  };

  renderDelivered = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Delivered</span>}
        {this.props.glyphDisplay &&
          <Coin className="ReadReceipt-icon" color="shamrock" size={this.props.iconSize}>
            <Glyph color="white" name="check" solo />
          </Coin>
        }
      </span>
    );
  };

  renderDeliveryError = () => {
    return (
      <span>
        {this.props.labelDisplay &&
          <span>
            {this.props.errorCount && this.props.errorCount + ' '}
            {(this.props.errorCount && this.props.errorCount > 1) ?
              'Delivery errors' :
              'Delivery error'
            }
          </span>
        }
        {this.props.glyphDisplay &&
          <Coin
            className="ReadReceipt-icon"
            border="sunrise"
            size={this.props.iconSize}>
            <Glyph color="sunrise" name="explanation" solo />
          </Coin>
        }
      </span>
    );
  };

  renderPendingInitialAck = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Sending</span>}
        {this.props.glyphDisplay &&
          <CircleSpinner
            className="ReadReceipt-icon"
            color="shamrock"
            size="small"
          />
        }
      </span>
    );
  };

  renderRead = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Read</span>}
        {this.props.glyphDisplay &&
          <Coin className="ReadReceipt-icon" color="brand" size={this.props.iconSize}>
            <Glyph color="white" name="check" solo />
          </Coin>
        }
      </span>
    );
  };

  renderSent = () => {
    return (
      <span>
        {this.props.labelDisplay && <span>Sent</span>}
        {this.props.glyphDisplay &&
          <Coin className="ReadReceipt-icon" border="shamrock" size={this.props.iconSize}>
            <Glyph color="shamrock" name="check" solo />
          </Coin>
        }
      </span>
    );
  };

  render() {
    const presenter = {
      [DeliveryStatus.SENT]: this.renderSent,
      [DeliveryStatus.READ]: this.renderRead,
      [DeliveryStatus.DELIVERED]: this.renderDelivered,
      [DeliveryStatus.DELIVERY_ERROR]: this.renderDeliveryError,
      [DeliveryStatus.PENDING_INITIAL_ACK]: this.renderPendingInitialAck,
    }[this.props.status];

    return presenter && (
      <span
        className={cx('ReadReceipt', {
          'ReadReceipt-link': !!this.props.onClick,
        })}
        onClick={this.props.onClick}>
        {presenter()}
      </span>
    );
  }
}

export default ReadReceipt;



// WEBPACK FOOTER //
// ./src/chat/components/ReadReceipt.jsx